"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resendEmail = exports.getEmailsBySupplierId = exports.getEmailsByClientId = exports.deleteScheduledEmailGroupByRef = exports.addEmailToLog = void 0;
const utilities_1 = require("../utilities");
const addEmailToLog = async (supabase, obj) => {
    delete obj.events;
    const { data, error } = await supabase.from("email_log").insert(obj);
    if (!error) {
        return data;
    }
    return error;
};
exports.addEmailToLog = addEmailToLog;
const deleteScheduledEmailGroupByRef = async (supabase, ref) => {
    const { data, error } = await supabase
        .from("email_log")
        .delete()
        .eq("scheduled_ref", ref)
        .eq("status", "scheduled");
    if (!error) {
        return data;
    }
    return error;
};
exports.deleteScheduledEmailGroupByRef = deleteScheduledEmailGroupByRef;
const getEmailsByClientId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("email_log")
        .select(`*,
      template:email_templates!id(*),
      agent:agent_accounts!agent_id(*, agent_config:agent_configurations!agent_config_id(*)),
    client:user_profiles!client_id(*),
    order:orders!order_id(*),
    supplier:suppliers!id(*),
    events:email_log_events!id(*)`)
        .eq("client_id", id)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getEmailsByClientId = getEmailsByClientId;
const getEmailsBySupplierId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("email_log")
        .select(`*,
      template:email_templates!id(*),
      agent:agent_accounts!agent_id(*, agent_config:agent_configurations!agent_config_id(*)),
    client:user_profiles!client_id(*),
    order:orders!order_id(*),
    supplier:suppliers!id(*),
    events:email_log_events!id(*)`)
        .eq("supplier_id", id)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getEmailsBySupplierId = getEmailsBySupplierId;
const resendEmail = async (supabase, obj) => {
    const template_name = obj.template ? obj.template.name : "";
    delete obj.events;
    delete obj.template;
    delete obj.agent;
    delete obj.client;
    delete obj.supplier;
    delete obj.id;
    delete obj.created_at;
    obj.status = "pending";
    obj.open_date = null;
    obj.delivery_date = null;
    obj.processed_date = null;
    const { data, error } = await supabase.from("email_log").insert(obj);
    if (!error) {
        await (0, utilities_1.addOrderLog)(supabase, {
            type: "EMAIL",
            order_id: obj.order_id,
            detail: {
                type: "Email Sent",
                status: null,
                title: `${template_name}`,
                message: `Sent to ${obj.to_address}`,
            },
        });
        return data;
    }
    return error;
};
exports.resendEmail = resendEmail;
